import navigation from './navigation';

const coreModules = {
  init() {
    navigation.init();
  }
};

export default coreModules;
